import { Box, IconButton, VStack } from '@genial/components';
import React from 'react';

import { TableContent, TableContentItemColumn } from '../../../../components/TableContent';
import { TableHeadContainer } from '../../../../components/TableHead';
import { TextSkeleton } from '../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { ItemSeparator } from '../DynamicIOProductTable/desktop';

import { DynamicIOProductTableLoadingProps } from '.';

export const DynamicIOProductTableDesktopLoading: React.FC<DynamicIOProductTableLoadingProps> = ({
  columnsCount = 4,
  rowsCount = 1,
  showAction = true,
}) => {
  return (
    <VStack space="stack.nano" pt="stack.xxs">
      <TableHeadContainer>
        <Box flex={1}>
          <TextSkeleton w="45%" h="10px" />
        </Box>
        {Array.from({ length: columnsCount }, (_, index) => (
          <Box key={`desktop-head-${index}`} w="12%">
            <TextSkeleton w="80%" h="10px" />
          </Box>
        ))}
        {showAction && <Box w="inline.xs" />}
      </TableHeadContainer>

      <VStack>
        {Array.from({ length: rowsCount }, (_, rowIndex) => (
          <Box key={`desktop-row-${rowIndex}`}>
            {rowIndex > 0 && <ItemSeparator />}

            <TableContent direction="row" space={0}>
              <TableContentItemColumn flex={1}>
                <TextSkeleton w="60%" />
              </TableContentItemColumn>

              {Array.from({ length: columnsCount }, (__, columnIndex) => (
                <TableContentItemColumn key={`desktop-cell-${rowIndex}-${columnIndex}`} maxW="12%">
                  <TextSkeleton w="80%" />
                </TableContentItemColumn>
              ))}

              {showAction && (
                <TableContentItemColumn alignItems="flex-end" maxW="inline.xs">
                  <IconButton
                    testId="dynamic-io-product-table-desktop-loading"
                    isDisabled
                    icon="ChevronRight"
                    p={0}
                    backgroundColor="transparent"
                    iconColor="neutral.medium"
                    iconSize="xs"
                  />
                </TableContentItemColumn>
              )}
            </TableContent>
          </Box>
        ))}
      </VStack>
    </VStack>
  );
};
